import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await register(name, email, password);
      navigate("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-5 py-20">
      <h1 className="font-heading text-5xl font-900 uppercase tracking-tight mb-2">Join The Race</h1>
      <p className="text-[#A1A1AA] mb-8">Create your ChristRacing account.</p>
      <form onSubmit={submit} className="space-y-4">
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Full name" data-testid="register-name"
          className="w-full bg-[#121212] border border-white/10 px-4 py-3 text-white placeholder-[#52525B] focus:outline-none focus:border-[#E63946] transition-colors" />
        <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder="Email" data-testid="register-email"
          className="w-full bg-[#121212] border border-white/10 px-4 py-3 text-white placeholder-[#52525B] focus:outline-none focus:border-[#E63946] transition-colors" />
        <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" placeholder="Password" data-testid="register-password"
          className="w-full bg-[#121212] border border-white/10 px-4 py-3 text-white placeholder-[#52525B] focus:outline-none focus:border-[#E63946] transition-colors" />
        {error && <p className="text-[#E63946] text-sm" data-testid="register-error">{error}</p>}
        <button disabled={loading} data-testid="register-submit"
          className="w-full bg-[#E63946] hover:bg-[#FF4D5A] disabled:opacity-60 text-white font-semibold uppercase tracking-wider text-sm px-6 py-4 transition-colors">
          {loading ? "Creating…" : "Create Account"}
        </button>
      </form>
      <p className="text-sm text-[#A1A1AA] mt-6">
        Already have an account? <Link to="/login" className="text-[#C5A059] hover:text-white transition-colors">Sign in</Link>
      </p>
    </div>
  );
}
